var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Panel", {
    staticStyle: { "margin-top": "1em" },
    attrs: { collapsible: "" },
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function () {
            return [_vm._v("\n        Similar Predicted Interfaces\n    ")]
          },
          proxy: true,
        },
        {
          key: "toolbar-extra",
          fn: function () {
            return [
              _c(
                "v-btn",
                {
                  attrs: {
                    plain: "",
                    href: `${_vm.$axios.defaults.baseURL}/cluster/${_vm.$route.params.cluster}/similar-predictions?format=summary`,
                    target: "_blank",
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v(_vm._s(_vm.$MDI.Export)),
                  ]),
                  _vm._v("\n            Export\n        "),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        _vm.$route.params.cluster
          ? {
              key: "content",
              fn: function () {
                return [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.entries,
                      options: _vm.options,
                      "server-items-length": _vm.totalEntries,
                      loading: _vm.loading,
                      "footer-props": {
                        "items-per-page-options": [10, 20, 50, 100, -1],
                      },
                    },
                    on: {
                      "update:options": function ($event) {
                        _vm.options = $event
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header.structure",
                          fn: function ({ header }) {
                            return [
                              _vm._v(
                                "\n                " +
                                  _vm._s(header.text) +
                                  "\n                "
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "span",
                                              _vm._g({}, on),
                                              [
                                                _c("v-icon", _vm._g({}, on), [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$MDI.HelpCircleOutline
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "Click on a structure to superpose its interface on to the cluster representative in the structure viewer"
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.structure",
                          fn: function (prop) {
                            return [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple",
                                      value: { class: `primary--text` },
                                      expression: "{ class: `primary--text` }",
                                    },
                                  ],
                                  staticStyle: {
                                    "text-align": "center",
                                    cursor: "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit(
                                        "select",
                                        prop.item.accession
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticStyle: { height: "75px" },
                                    attrs: {
                                      src: _vm.getImage(prop.item.accession),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.uniprot",
                          fn: function (prop) {
                            return [
                              _c(
                                "div",
                                [
                                  prop.item.uniprot_id1
                                    ? _c("ExternalLinks", {
                                        attrs: {
                                          accession: prop.item.uniprot_id1,
                                          simple: "",
                                        },
                                      })
                                    : _c("span", [_vm._v("N/A")]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  prop.item.uniprot_id2
                                    ? _c("ExternalLinks", {
                                        attrs: {
                                          accession: prop.item.uniprot_id2,
                                          simple: "",
                                        },
                                      })
                                    : _c("span", [_vm._v("N/A")]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.tax_id",
                          fn: function (prop) {
                            return [
                              prop.item.tax_id1 && prop.item.tax_id1.name
                                ? _c(
                                    "div",
                                    [
                                      _c("TaxSpan", {
                                        attrs: { taxonomy: prop.item.tax_id1 },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("div", [_vm._v("N/A")]),
                              _vm._v(" "),
                              prop.item.tax_id2 && prop.item.tax_id2.name
                                ? _c(
                                    "div",
                                    [
                                      _c("TaxSpan", {
                                        attrs: { taxonomy: prop.item.tax_id2 },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("div", [_vm._v("N/A")]),
                            ]
                          },
                        },
                        {
                          key: "item.tm_score",
                          fn: function (prop) {
                            return [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    prop.item.tm_score != null
                                      ? prop.item.tm_score.toFixed(3)
                                      : "N/A"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.tm_score_target",
                          fn: function (prop) {
                            return [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    prop.item.tm_score_target != null
                                      ? prop.item.tm_score_target.toFixed(3)
                                      : "N/A"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.source",
                          fn: function (prop) {
                            return [
                              prop.item.source === "HumanPPI" &&
                              prop.item.uniprot_id1 &&
                              prop.item.uniprot_id2
                                ? _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: _vm.sourceColor(
                                          prop.item.source
                                        ),
                                        outlined: "",
                                        href: `http://prodata.swmed.edu/humanPPI/results/${prop.item.uniprot_id1}_${prop.item.uniprot_id2}`,
                                        target: "_blank",
                                        rel: "noopener",
                                      },
                                    },
                                    [_vm._v(_vm._s(prop.item.source))]
                                  )
                                : _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: _vm.sourceColor(
                                          prop.item.source
                                        ),
                                        outlined: "",
                                      },
                                    },
                                    [_vm._v(_vm._s(prop.item.source))]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1305429855
                    ),
                  }),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }